import {
  SourcingPurchaseParameters,
  SourcingService,
} from 'api-clients/monolith';

type UpdateCampaignParams = {
  sourcingPurchaseId: string;
  requestBody: SourcingPurchaseParameters;
};

export function updateCampaign(params: UpdateCampaignParams) {
  const { sourcingPurchaseId, requestBody } = params;

  return SourcingService.putInternalApiSourcingSourcingPurchases(
    sourcingPurchaseId,
    requestBody,
  );
}
